module.exports = __webpack_public_path__ + "img/tabs-bg-2.9cc0f0f0.png";